import React from 'react';

const ContactPersonInput = ({input, label, type, isModal, isOptional, meta: {touched, error, warning}}) => {


    const formGroupErrorClass = (touched && error) ? 'has-danger' : '';
    const inputErrorClass = (touched && error) ? 'form-control-danger' : '';
    const errorMessage = touched && error ? error : '';
    const cssClass = 'col-xs col-sm-2 col-xl-1';
    const optionalSpan = isOptional ? <span className="text-muted">(valgfri)</span> : null;
    return (
        <div className={`form-group row ${formGroupErrorClass}`}>
            <label className="col-sm-2 col-form-label">
                <b>
                    {label} {optionalSpan}
                </b>
            </label>
            <div className={`col`}>
                <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                <div className="input-group-addon phone-code-placeholder">+45</div>
                <input
                    {...input}
                    className={`form-control ${inputErrorClass}`}
                    type={type}
                    placeholder="XXXXXXXX"
                    autoComplete={input.name + '-new'}
                />
                </div>
                <div className="form-control-feedback">{errorMessage}</div>
            </div>
        </div>

    );
};

export default ContactPersonInput;




// WEBPACK FOOTER //
// ./web/src/components/contact-person/ContactPersonPhoneInput.jsx